export default __webpack_public_path__ + "static/media/964.f7332c6c.png";